import { MenuItem } from "./MenuItem";

export class Menu{

    constructor() {
        this.Links = new Array<MenuItem>();
    }

    public Links : MenuItem[];
}